import React from 'react';
import { Stack } from '@mui/material';
import styles from './styles.module.scss';

export function InitialPage() {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height: '50vh' }}>
      <h1 className={styles.title_reports}>
        Escolha acima a opção de Dashboard que você que acessar...
      </h1>
    </Stack>
  );
}
